// extracted by mini-css-extract-plugin
export default {"actionButtons":"styles_actionButtons__Y7cdi","actionButton":"styles_actionButton__+ZxDb","noDetailsClick":"styles_noDetailsClick__0aTee"};